import { WorkModel } from '@Entities/work/work'
import { WorkType } from '@Components/ViewWork/work-type'
import { ZodFormattedError } from 'zod'
import React, { useState } from 'react'
import RecordingsTable from '@Components/ViewWork/RecordingsTable'
import { PaginationBody } from '@Entities/pagination'
import ViewWorkSection from '@Components/ViewWork/ViewWorkSection'
import generateEditLink from '@App/helpers/generate-edit-link'
import EditButton from '@Components/ViewWork/EditButton'
import CustomToolTip from '@Components/Tooltips/CustomToolTip'
import './index.scss'
import { observer } from 'mobx-react'
import { RecordingModel } from '@Entities/work/recording-model'

interface RecordingsSectionProps {
    work: WorkModel
    rightsholderId?: number
    workType?: WorkType
    editing?: boolean
    errors?: ZodFormattedError<RecordingModel[]>
}

const RecordingsSection = ({ work, rightsholderId, workType, editing, errors }: RecordingsSectionProps) => {
    const PAGE_LIMIT = 10
    const recordingLen = work.recordings.length

    const [currentPage, setCurrentPage] = useState(1)
    const [recordingPage, setRecordingPage] = useState(work.recordings.slice(0, PAGE_LIMIT))

    const handlePage = (pagination: PaginationBody) => {
        const newPage = pagination.page ?? 1
        setCurrentPage(newPage)
        setRecordingPage(work.recordings.slice((newPage - 1) * PAGE_LIMIT, newPage * PAGE_LIMIT))
    }

    const recordingsEditLink = generateEditLink('recordings', work.id as number, rightsholderId, workType)

    return (
        <ViewWorkSection
            valid={editing !== undefined ? !errors : undefined}
            icon="recordings"
            title="Recordings"
            count={recordingLen}
            rightData={
                <div className="recordings-right-data">
                    <CustomToolTip
                        info="This displays recording data that will be matched to your work. Any data input in the works registration process will not be shown here but is stored in the database."
                        type="?"
                        inverse
                    />
                    {editing && <EditButton linkTo={recordingsEditLink} workType={workType} wizardFlowIndex={4} />}
                </div>
            }
        >
            <RecordingsTable
                recordings={recordingPage}
                handlePage={handlePage}
                errors={errors}
                totalRecordings={recordingLen}
                currentPage={currentPage}
                recordingType="registration"
                editing={editing}
            />
        </ViewWorkSection>
    )
}

export default observer(RecordingsSection)
